import { Trans } from '@lingui/react'

import InputCheckbox from 'views/components/molecules/InputCheckbox'

const SumBoxZavaCb = () => (
  <div className="u-border--top">
    <p className="u-margin-large--bottom u-margin-large--top">
      <InputCheckbox id="zava" name="cart-sumBox-zava-input">
        <Trans id="general.cartSumBox.zava" />
      </InputCheckbox>
    </p>
  </div>
)

export default SumBoxZavaCb
